import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import videojs from 'video.js';
import { css, StyleSheet } from 'aphrodite';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { ZIndex } from '../../constants';
import { Colors } from '../../styles';
import { TriangleIcon, TriangleDirection } from '../../atoms/icons/triangle_icon';
const CompleteButton = observer(class CompleteButton extends React.Component {
    render() {
        if (!this.props.vm.visible) {
            return null;
        }
        return (React.createElement("div", { className: css(styles.container, this.props.vm.isFullScreen && styles.containerFullScreen) },
            React.createElement("div", { className: css(styles.button), onClick: this.props.onClickComplete },
                React.createElement("div", { className: css(styles.inner) },
                    React.createElement(TriangleIcon, { color: Colors.Black, direction: TriangleDirection.right, classObject: styles.icon }),
                    React.createElement("span", { className: css(styles.label) }, "\u5B8C\u4E86\u3059\u308B")))));
    }
});
export class VjsCompleteButtonVM {
    constructor() {
        // エンディング開始秒に到達したら true になり、完了ボタンを表示する
        Object.defineProperty(this, "visible", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        // フルスクリーン時はフルスクリーンボタンの位置が上がるため、それに合わせて配置を切り替える
        Object.defineProperty(this, "isFullScreen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        makeObservable(this, {
            visible: observable,
            isFullScreen: observable,
        });
    }
    setIsFullScreen(isFullScreen) {
        this.isFullScreen = isFullScreen;
    }
}
export default class VjsCompleteButton extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        Object.defineProperty(this, "completeButtonOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "completeButtonPlayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "vm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.completeButtonOptions = options;
        this.completeButtonPlayer = player;
        this.vm = options.vm;
        this.mount = this.mount.bind(this);
        this.completeButtonPlayer.ready(() => {
            this.mount();
        });
    }
    mount() {
        const root = ReactDOM.createRoot(this.el());
        root.render(React.createElement(CompleteButton, { vm: this.completeButtonOptions.vm, onClickComplete: this.completeButtonOptions.onClickComplete }));
    }
}
const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        right: 0,
        // フルスクリーン・外部デバイス表示ボタンの上に配置する
        // （video-js.css の .vjs-fullscreen-control: bottom 40px + 高さ 20px の上端に揃える）
        bottom: 60,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        padding: '0 12px 12px 0',
        gap: 10,
        zIndex: ZIndex.VideoPlayButton,
    },
    // フルスクリーン時はフルスクリーンボタンが上がる（margin-bottom 60px）ため、それに合わせる
    containerFullScreen: {
        bottom: 80,
    },
    button: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '7px 0',
        gap: 6,
        width: 91,
        height: 32,
        background: 'rgba(255, 255, 255, 0.8)',
        borderRadius: 17,
        cursor: 'pointer',
    },
    inner: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
    },
    icon: {
        flexShrink: 0,
    },
    label: {
        fontWeight: 'bold',
        fontSize: 11,
        lineHeight: 1.4,
        letterSpacing: '0.08em',
        textAlign: 'center',
        whiteSpace: 'nowrap',
        // video.js プレイヤー内は .video-js の color: #fff を継承するため、デフォルト文字色でも明示指定が必要
        color: Colors.Black,
    },
});
